var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FullscreenDialog",
    {
      ref: "dialog",
      attrs: {
        "animation-name": "zoomIn",
        title: _vm.$t("pc_biz_o2o_plan_detail" /* 培训计划详情 */),
        visible: _vm.visible,
        "before-close": function (done) {
          return done(false)
        },
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "yxtbiz-trainPlanAudit_iframe_wrapper" }, [
        _c("iframe", {
          attrs: {
            width: "100%",
            height: "100%",
            frameborder: "0",
            scrolling: "auto",
            allowfullscreen: "true",
            webkitallowfullscreen: "true",
            mozallowfullscreen: "true",
            src: _vm.src,
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }